import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import useRoutes from "./AuthProctectedRoutes";
import RouteGuard from "./route.guard";

const RouteIndex = () => {
  const authProctectedRouts = useRoutes();
  return (
    <React.Fragment>
      <Routes>
        {authProctectedRouts.map((route: any, idx: number) => {
          if (route.guard) {
            const { valid, redirect, state } = route.guard;
            return (
              <Route
                key={route.path}
                element={
                  <RouteGuard valid={valid} redirect={redirect} state={state} />
                }
              >
                <Route
                  key={idx}
                  path={route.path}
                  element={<route.component />}
                />
              </Route>
            );
          }
          if (route.path) {
            return (
              <Route
                key={idx}
                path={route.path}
                element={
                  <>
                    <route.component />
                  </>
                }
              />
            );
          }
        })}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
